<template>
    <div v-loading="dataLoading">
        <template v-if="data">
            <div class="group">
                <div class="page-group-title"><span>基本信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单ID: </span>{{data.orderId}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单编号: </span>{{data.sn}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付状态: </span>{{data.paymentStatus == 1  ? '未支付' : '已支付'}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单状态: </span>{{orderStatus.get(data.orderStatus)}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单终端: </span>{{data.terminal}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单时间: </span>{{data.createTime}}</el-col>
                    </el-row>
                </el-card>
            </div>
            <div v-if="data.info && data.info.orderType == 1" class="group MT20">
                <div class="page-group-title"><span>演出信息</span></div>
                <el-card v-for="(item,index) in data.info.goodsInfo" :key="index" shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24">{{item.goodsName}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">演出ID: </span>{{item.goodsId}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">演出城市: </span>{{item.city}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">演出场地: </span>{{item.site}}</el-col>
                    </el-row>
                 </el-card>
            </div>
            <div v-else-if="data.info && data.info.orderType == 2" class="group MT20">
                <div class="page-group-title"><span>众筹信息</span></div>
                <el-card v-for="(item,index) in data.info.goodsInfo" :key="index" shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24">{{item.goodsName}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">众筹ID: </span>{{item.goodsId}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">发起人身份: </span>{{$userType.get(item.userType)}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">发起人: </span>{{item.userName}}</el-col>
                    </el-row>
                 </el-card>
            </div>
            <div v-else-if="data.info && data.info.orderType == 3" class="group MT20">
                <div class="page-group-title"><span>消费信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :span="8"><span class="color-info">订单总额: </span>￥{{data.info.totalAmount}}</el-col>
                        <el-col :span="8"><span class="color-info">商品总额: </span>￥{{data.info.goodsAmount}}</el-col>
                        <el-col :span="8"><span class="color-info">运费: </span>￥{{data.info.freight}}</el-col>
                        <el-col :span="8"><span class="color-info">实付金额: </span>￥{{data.info.payAmount}}</el-col>
                        <el-col :span="8"><span class="color-info">优惠券: </span>￥{{data.info.discountAmount}}</el-col>
						<el-col :span="8"><span class="color-info">有效商品数: </span>{{data.info.num}}</el-col>
                    </el-row>

                    <div v-for="(item,index) in data.info.goodsInfo" :key="index">
                        <el-divider></el-divider>
                        <div class="page-group-title font16"><span>{{item.name}} <span class="color-info">{{item.skuDesc}}</span></span></div>
                        <el-row :gutter="40">
                            <el-col :span="8"><span class="color-info">商品ID: </span>{{item.goodsId}}</el-col>
                            <el-col :span="8"><span class="color-info">单价: </span>￥{{item.price}}</el-col>
                            <el-col :span="8"><span class="color-info">数量: </span>{{item.num}}</el-col>
                        </el-row>
                        <el-row :gutter="40">
                            <el-col :span="8"><span class="color-info">总额: </span>{{item.totalAmount}}</el-col>
                            <el-col :span="8"><span class="color-info">待退款数: </span>{{item.waitRefundNum}}</el-col>
                            <el-col :span="8"><span class="color-info">已退款数量: </span>{{item.refundNum}}</el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>购买人信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户ID: </span>{{data.customerId}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户名: </span>{{data.buyerName}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">账号手机: </span>{{data.buyerUserPhone}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">身份: </span>{{data.buyerUserType}}</el-col>
                    </el-row>
                 </el-card>
            </div>
            <div v-for="(item,index) in data.recordDetail" :key="index" class="group MT20">
                <div class="page-group-title"><span>{{item.payPlatformCodeName}}支付信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col><span class="color-info">支付平台交易号: </span>{{item.outTradeNo}}</el-col>
                        <el-col><span class="color-info">支付时间: </span>{{item.successTime}}</el-col>
                        <el-col><span class="color-info">实际支付: </span>￥{{item.payAmount}}</el-col>
                        <el-col v-if="index == 0" class="MT10 color-danger">此为用户最先支付的记录，需要保留（不退）</el-col>
                        <el-col v-else class="MT10 color-danger">此为用户重复支付记录，
                            {{data.refundTradeNo && item.outTradeNo == data.refundTradeNo  ? '已被标记处理' : '请先退款，然后到此页面进行标记'}}
                        </el-col>
                    </el-row>
                 </el-card>
            </div>
            
            <div class="MT20">
                <el-alert type="warning" title="在完成处理前，建议先为用户进行退款，处理完成后，重复支付的记录会被标记为已处理" show-icon :closable="false"></el-alert>
            </div>
            <div class="group MT20">
                <el-button @click="goBack">返回</el-button>
                <el-button
                    v-if="$utils.have('/activityRepeatOrder/markRefund') && !data.markRefund"
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >标记为已处理</el-button
                >
            </div>
        </template>
    </div>
</template>

<script>
export default {
     props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    data(){
        return{
            dataLoading: false,
            redirect: this.$route.query.redirect,
            data:null,
            btnLoading: false,
            // flag:'',
        }
    },
    computed:{
        orderStatus(){
            return new Map([
                [1,'待支付'],
                [2,'待发货'],
                [3,'部分发货'],
                [4,'已发货'],
                [5,'已完成'],
                [6,'已过期'],
            ])
        },
       
    },
    created(){
        if (this.id) {
            this.getDataDetail();
        }
    },
    methods:{
         //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/activityRepeatOrder/detail",
                params: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = {...result};
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },

        onSubmit(){
            // if(!this.flag || this.flag == ''){
            //     return this.$message.error('请至少选择一个支付平台标记为【已退款】');
            // }
            this.btnLoading = true;
            this.$request({
                url: "/activityRepeatOrder/markRefund",
                params: { 
                    id: this.id,
                    // outTradeNo: this.flag
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
						this.$message.success("操作成功");
						this.goBack();				
                        
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        }
    }
}
</script>


<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 26px;
    }
}
</style>